var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon',{attrs:{"icon":"users","action":_vm.goTo,"title":"ユーザー管理"}})}
var staticRenderFns = []

export { render, staticRenderFns }